export default [
    {
        path: '/',
        component: () => import('@/views/layout/layout.vue'),
        redirect: '/home',
        children: [{
            path: 'home',
            component: () => import('@/views/home/home.vue')
        }, {
            path: 'article/list',
            component: () => import('@/views/article/list/article.list.vue')
        }, {
            path: 'article/detail/:artId*',
            component: () => import('@/views/article/detail/article.detail.vue')
        }, {
            path: 'article/search/:word*',
            component: () => import('@/views/article/search/article.search.vue')
        }]
    },
    {
        path: '/article/h5',
        component: () => import('@/views/article/h5/article.h5.vue')
    }
];
